export default state => state.ui.desktopBanner;
